
var shopPages = [
  {
    id:'guid-p-shop-1',
    name:'首页',
    //schema:userList,
  },

]

export default shopPages;